// Images
require.context("@/images/front", true);

// CSS
import "swiper/swiper-bundle.css";
import "simplebar/dist/simplebar.min.css";
import "select2/dist/css/select2.css";
import "@/stylesheets/front/style.scss";

// JS
import "jquery";
import "gsap";
import "swiper";
import "simplebar";
import "@/src/front/common";
import "@/src/front/game-detail";
import "@/src/front/game-top";
import "@/controllers/front";
